import React from "react";
import TenantAppList from "./TenantAppList";
import TenantUsersList from "./TenantUsersList";
import TenantAdminRoute from "../../routes/TenantAdminRoute";
import Page from "@jumbo/shared/Page";
import {Navigate} from "react-router-dom";

function getTenantName() {
    const hostname = window.location.hostname;
    // Remove protocol (http:// or https://) if present
    const cleanOrigin = hostname.replace(/^(https?:\/\/)/, "");
    const parts = cleanOrigin.split(".");
    let tenant;
    if (parts.length >= 2) {
        tenant = parts[0];
    } else {
        tenant = process.env.REACT_APP_LOCAL_TENANT; // Fallback to a default tenant if not found
    }
    return tenant;
}
const isCrowellTenant = process.env.REACT_APP_NUMBER_GENERATOR_TENANT?.includes(getTenantName()?.toLowerCase());

const tenantRoutes = [
{
    path: "/dashboard",
    // element: <TenantAdminRoute element={<Page component={TenantAppList}/>} />
    element: isCrowellTenant
        ? <Navigate to="/file-number-generator" replace />
        : <TenantAdminRoute element={<Page component={TenantAppList}/>} />

},
{
    path: "/users",
    element: <TenantAdminRoute element ={<Page component={TenantUsersList}/>} />
}
];

export default tenantRoutes;